'use client'

import Script from "next/script";

export interface CDCProps {
  contents: {
    type: 'login' | 'register' | 'subscribe' | 'profile' | 'forget-password';
  };
}

const scriptType = {
  login: () => {
    gigya.accounts.showScreenSet({
      screenSet: "SML-RegistrationLogin",
      startScreen: "gigya-login-screen",
      containerID: "screen",
    });
    //redirect while login success
    gigya.accounts.addEventHandlers({
      onLogin: function () {
        document.location = "./profile";
      },
    });
  },

  profile: () => {
    gigya.accounts.showScreenSet({
      screenSet: "SML-ProfileUpdate",
      startScreen: "gigya-update-profile-screen",
      containerID: "screen",
    });
  },

  register: () => {
    gigya.accounts.showScreenSet({
      screenSet: "SML-RegistrationLogin",
      startScreen: "gigya-register-screen",
      containerID: "screen",
    });
    //redirect while register success
    gigya.accounts.addEventHandlers({
      onLogin: function () {
        document.location = "./profile.php";
      },
    });
  },

  subscribe: () => {
    gigya.accounts.showScreenSet({
      screenSet: "SML-LiteRegistration",
      startScreen: "gigya-subscribe-with-email-screen",
      containerID: "screen",
    });
  },

  "forget-password": () => {
    gigya.accounts.showScreenSet({
      screenSet: "SML-RegistrationLogin",
      startScreen: "gigya-reset-password-screen",
      containerID: "screen",
    });
  },
};

export default function CDC(props: CDCProps) {
  return (
    <>
       <Script
        async
        type="text/javascript"
        lang="javascript"
        src={process.env.NEXT_PUBLIC_CDC_URL}
        onReady={() => {
          scriptType[props.contents.type]?.();
        }}
      ></Script>

      <div className="overflow-x-hidden [&_*]:!whitespace-normal min-h-[400px] pt-16 pb-32 xl:pt-20 bg-darkgold">
        <div className="max-w-screen-xl mx-auto bg-white mt-20 rounded-2xl w-fit" id="screen"></div>
      </div>
    </>
  );
}